import crypto from "crypto-browserify";
import base62 from "base62";

import { DayMap, MonthMap } from "./constants";

const charset: string =
  "~9876543210ABCDEFGHIJKLMNOPQRSTU$#@%!abcdefghijklmnopqrstuvw-=";
base62.setCharacterSet(charset);

export function validateEmail(email: string): boolean {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}
export function formatDate(timeStamp: number): string {
  const date = new Date(timeStamp);

  let prefix;
  const month = date.getMonth();
  const dayOf = date.getDate();
  const day = date.getDay();
  let hours = date.getHours();
  const minutes = `0${date.getMinutes()}`;
  const seconds = `0${date.getSeconds()}`;
  let mTime;
  if (hours > 11) {
    hours -= 12;
    mTime = "PM";
  } else {
    mTime = "AM";
  }
  if (hours === 0) {
    hours = 12;
  }

  const now = Date.now();
  const dayOfNow = new Date(now).getDate();
  const dif = now - timeStamp;
  const mSecInWeek = 604800000;

  if (dayOfNow === dayOf) {
    // same day
    prefix = "";
  } else if (dif > mSecInWeek) {
    prefix = `${MonthMap[month as keyof typeof MonthMap]} ${dayOf}`;
    const now = new Date(Date.now());
    const year = date.getFullYear();
    const thisYear = now.getFullYear();
    if (thisYear > year) {
      prefix = `${prefix} ${thisYear}`;
    }
  } else {
    // same week
    prefix = DayMap[day as keyof typeof DayMap];
  }

  const dateString = `${prefix} ${hours}:${minutes.substr(-2)}:${seconds.substr(
    -2,
  )} ${mTime}`;

  return dateString;
}

export function unixToMins(unixtime: number): string {
  const time = unixtime / 1000;
  const min = Math.floor(time / 60);
  const sec = Math.floor(time % 60);
  return `${min}m ${sec}s `;
}

export function stringInputValidate(stringVal: string): boolean {
  const regex = /[<>\][]]/g;
  if (stringVal === "") return false;

  if (stringVal.search(regex)) {
    return false;
  }
  return true;
}

export function createSortedKeyMap(
  data: Record<string, any>,
  param: string,
  order: "asc" | "desc" = "asc",
): Record<string, any> {
  const KeyMap: Record<string, string> = {};
  let i = 0;

  for (const [key, value] of Object.entries(data)) {
    const fKey = value[param] + i;
    KeyMap[fKey] = key;
    i++;
  }
  const sortedKeys = Object.keys(KeyMap).sort();
  if (order === "desc") {
    sortedKeys.reverse();
  }

  const SortedMap: Record<string, any> = {};

  for (let i = 0; i < sortedKeys.length; i++) {
    const key = sortedKeys[i];
    const newData = data[KeyMap[key]];
    SortedMap[newData?.id] = newData;
  }

  return SortedMap;
}

export function encode(val: number): string {
  return base62.encode(val);
}

export function decode(val: string): number {
  return base62.decode(val);
}

export function createHash(val: string): string {
  return crypto.createHash("sha256").update(val).digest("hex").slice(0, 32);
}

export function formatPhoneNumber(unformattedNum: string | number): string {
  let valString = unformattedNum.toString();
  if (valString.match(/^\+1/)) {
    valString = valString.slice(2);
  }
  const { length } = valString;
  if (length >= 4) {
    valString = `${valString.slice(0, 3)}-${valString.slice(3)}`;
  }
  if (length >= 7) {
    valString = `${valString.slice(0, 7)}-${valString.slice(7)}`;
  }
  if (length >= 11) {
    valString = valString.slice(0, 12);
  }
  return valString;
}
